
import Vue from 'vue'

export default Vue.extend({
    props: {
        clause: Object as () => Connex.Thor.Transaction['clauses'][number]
    },
    data: () => {
        return {
            view: 'raw' as 'raw' | 'decoded',
            decodedViewCreated: false
        }
    },
    computed: {
        isMethod(): boolean { return !!this.clause.to && this.clause.data.length >= 10 }
    },
    watch: {
        view(newVal) {
            if (newVal === 'decoded') {
                this.decodedViewCreated = true
            }
        }
    }
})
